import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-design-issue-all-grid',
  templateUrl: './project-design-issue-all-grid.component.html',
  styleUrls: ['./project-design-issue-all-grid.component.css']
})
export class ProjectDesignIssueAllGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/project-design-issue-total/project-design-issue-all-grid/project-design-issue-all-grid.component.ts